function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.562 1.324l6.179 10.703a.649.649 0 01-.562.973H.821a.649.649 0 01-.562-.973L6.44 1.324a.649.649 0 011.123 0zm-1.21 8.433v1.297h1.297V9.757H6.35zm0-4.54v3.242h1.297V5.216H6.35z",
  fill: "currentColor"
});

var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgAlert;